import {
    ActionCreatorProps,
    createAction,
    props
} from '@ngrx/store';
import {
    DATIQ_INPUT_AUTOCOMPLETE,
    DATIQ_INPUT_CHIP,
    DATIQ_INPUT_OPTION,
    DatiqAnalyticsInputInteraction,
    IDatiqAnalyticsEvent,
} from '@dat/datiq-core/models';

const createActionName: (name: string) => string = (name: string) => {
    return `[Datiq ${DATIQ_INPUT_AUTOCOMPLETE}] ${name}`;
};
const defaultProp: ActionCreatorProps<IDatiqAnalyticsEvent> =
    props<IDatiqAnalyticsEvent>();
export const searchDatiqAutocompleteName = createActionName(
    `${DatiqAnalyticsInputInteraction.Search}`
);
export const searchDatiqAutocomplete = createAction(
    searchDatiqAutocompleteName,
    defaultProp
);
export const selectDatiqAutocompleteOptionName: string = createActionName(
    `${DATIQ_INPUT_OPTION} ${DatiqAnalyticsInputInteraction.Selected}`
);
export const selectDatiqAutocompleteOption = createAction(
    selectDatiqAutocompleteOptionName,
    defaultProp
);
export const selectDatiqAutocompleteOptionCheckName: string = createActionName(
    `${DatiqAnalyticsInputInteraction.Check}`
);
export const selectDatiqAutocompleteOptionCheck = createAction(
    selectDatiqAutocompleteOptionCheckName,
    defaultProp
);
export const selectDatiqAutocompleteOptionRadioName: string = createActionName(
    `${DatiqAnalyticsInputInteraction.CheckRadio}`
);
export const selectDatiqAutocompleteOptionRadio = createAction(
    selectDatiqAutocompleteOptionRadioName,
    defaultProp
);
export const deselectDatiqAutocompleteOptionName: string = createActionName(
    `${DatiqAnalyticsInputInteraction.Deselected}`
);
export const deselectDatiqAutocompleteOption = createAction(
    deselectDatiqAutocompleteOptionName,
    defaultProp
);
export const deselectDatiqAutocompleteOptionCheckName: string =
    createActionName(`${DatiqAnalyticsInputInteraction.Uncheck}`);
export const deselectDatiqAutocompleteOptionCheck = createAction(
    deselectDatiqAutocompleteOptionCheckName,
    defaultProp
);
export const deselectDatiqAutocompleteOptionRadioName: string =
    createActionName(`${DatiqAnalyticsInputInteraction.UncheckRadio}`);
export const deselectDatiqAutocompleteOptionRadio = createAction(
    deselectDatiqAutocompleteOptionRadioName,
    defaultProp
);
export const removeDatiqAutocompleteOptionChipName: string = createActionName(
    `${DATIQ_INPUT_CHIP} ${DatiqAnalyticsInputInteraction.Removed}`
);
export const removeDatiqAutocompleteOptionChip = createAction(
    removeDatiqAutocompleteOptionChipName,
    defaultProp
);
export const removeDatiqAutocompleteOptionChipClickName: string =
    createActionName(
        `${DATIQ_INPUT_CHIP} ${DatiqAnalyticsInputInteraction.Removed} ${DatiqAnalyticsInputInteraction.Click}`
    );
export const removeDatiqAutocompleteOptionChipClick = createAction(
    removeDatiqAutocompleteOptionChipClickName,
    defaultProp
);
export const removeDatiqAutocompleteOptionChipKeypressName: string =
    createActionName(
        `${DATIQ_INPUT_CHIP} ${DatiqAnalyticsInputInteraction.Removed} ${DatiqAnalyticsInputInteraction.KeyPressDelete}`
    );
export const removeDatiqAutocompleteOptionChipKeypress = createAction(
    removeDatiqAutocompleteOptionChipKeypressName,
    defaultProp
);
